export class NanoIdGenerator {
  // Custom nanoid implementation
  private static customNanoid(alphabet: string, size: number): string {
    let id = '';
    for (let i = 0; i < size; i++) {
      id += alphabet[Math.floor(Math.random() * alphabet.length)];
    }
    return id;
  }

  // Custom alphabet including consonants, vowels, and numbers
  private static readonly consonants = 'BCDFGHJKLMNPQRSTVWXYZ';
  private static readonly vowels = 'AEIOU';
  private static readonly digits = '23456789'; // Excluding 0 and 1 to avoid confusion with O and I

  // Function to generate a readable and unique ID
  public static generateReadableId(): string {
    let combinedAlphabet = '';

    // Construct an alphabet that includes consonants, vowels, and digits
    const maxLength = Math.max(this.consonants.length, this.vowels.length, this.digits.length);

    for (let i = 0; i < maxLength; i++) {
      if (i < this.consonants.length) combinedAlphabet += this.consonants[i];
      if (i < this.vowels.length) combinedAlphabet += this.vowels[i];
      if (i < this.digits.length) combinedAlphabet += this.digits[i];
    }

    // Generate the ID with the custom alphabet and desired length (10 characters)
    return this.customNanoid(combinedAlphabet, 10);
  }
}
